export default "__VITE_ASSET__PUdOiuyl__"